import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Socios',
    path: '/empresa/socio/:id',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const SocioPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Socios</PageTitle>
      <View />
    </>
  );
};

export { SocioPage };
